module.exports = __webpack_public_path__ + "assets/img/server__load_progress_on.6e502835.webp";